var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11041",
    "data-name": "Group 11041",
    transform: "translate(23725 19915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(-23725 -19915)",
    fill: "#ffeaae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4332",
    "data-name": "Group 4332",
    transform: "translate(-23719 -19909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3999",
    "data-name": "Group 3999",
    transform: "translate(0.155 3.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3996",
    "data-name": "Group 3996",
    transform: "translate(0.328 0.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M50.813,700.743a.69.69,0,0,0-.022,1.122l.892.92a.932.932,0,0,0,.875.266,2.8,2.8,0,0,1,2.624.8,1.619,1.619,0,0,1,.294,2.21.54.54,0,0,0,.1.737l.892.92a1.19,1.19,0,0,0,1.377.276l10-6.05a.691.691,0,0,0,.022-1.122l-.892-.92a.934.934,0,0,0-.875-.266,2.8,2.8,0,0,1-2.624-.8,1.619,1.619,0,0,1-.294-2.21.539.539,0,0,0-.1-.736l-.892-.92a1.19,1.19,0,0,0-1.377-.276Z",
    transform: "translate(-50.517 -694.574)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3997",
    "data-name": "Group 3997",
    transform: "translate(0.328 0.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M66.972,699.9a.934.934,0,0,0-.875-.266,2.8,2.8,0,0,1-2.624-.8,1.619,1.619,0,0,1-.293-2.21.539.539,0,0,0-.1-.736l-.892-.92a1.19,1.19,0,0,0-1.377-.276l-10,6.05a.69.69,0,0,0-.022,1.122l.892.92a.932.932,0,0,0,.875.266,2.8,2.8,0,0,1,2.624.8,1.619,1.619,0,0,1,.294,2.21.54.54,0,0,0,.1.737l.892.92a1.232,1.232,0,0,0,1.264.33l9.692-7.682Z",
    transform: "translate(-50.517 -694.574)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3998",
    "data-name": "Group 3998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M50.21,701.272a1.637,1.637,0,0,1-1.152-.493l-.892-.92a.864.864,0,0,1-.109-1.179,1.309,1.309,0,0,0-.282-1.767,2.5,2.5,0,0,0-2.3-.712,1.256,1.256,0,0,1-1.2-.353l-.892-.92a1.177,1.177,0,0,1-.359-.957.914.914,0,0,1,.446-.674l10-6.05a1.511,1.511,0,0,1,1.782.328l.892.92a.864.864,0,0,1,.109,1.179,1.309,1.309,0,0,0,.282,1.767,2.5,2.5,0,0,0,2.3.712,1.256,1.256,0,0,1,1.2.353l.892.92a1.177,1.177,0,0,1,.359.957.914.914,0,0,1-.446.674L57.5,697.074a.328.328,0,0,1-.339-.561L60.5,694.5a.264.264,0,0,0,.136-.2.541.541,0,0,0-.18-.417l-.892-.92a.611.611,0,0,0-.552-.178,3.141,3.141,0,0,1-2.947-.887,1.933,1.933,0,0,1-.305-2.653c.055-.063.019-.186-.085-.293l-.892-.92a.876.876,0,0,0-.973-.224l-10,6.05a.264.264,0,0,0-.136.2.542.542,0,0,0,.18.417l.892.92a.611.611,0,0,0,.552.178,3.141,3.141,0,0,1,2.947.887,1.933,1.933,0,0,1,.305,2.653c-.055.063-.019.186.085.294l.892.92a.877.877,0,0,0,.973.224l5.562-3.365a.328.328,0,0,1,.339.561l-5.562,3.365A1.212,1.212,0,0,1,50.21,701.272Z",
    transform: "translate(-43.016 -687.081)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4016",
    "data-name": "Group 4016",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4000",
    "data-name": "Group 4000",
    transform: "translate(0.328 0.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M47.233,621.1a.934.934,0,0,0,0,1.321l.869.869a.691.691,0,0,0,.841.106,2.076,2.076,0,0,1,2.842,2.842.692.692,0,0,0,.106.841l.869.869a.934.934,0,0,0,1.321,0l9.44-9.44a.934.934,0,0,0,0-1.321l-.869-.869a.692.692,0,0,0-.841-.106,2.076,2.076,0,0,1-2.842-2.842.691.691,0,0,0-.106-.84l-.869-.869a.934.934,0,0,0-1.321,0Z",
    transform: "translate(-46.959 -611.389)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001",
    transform: "translate(6.017 5.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M188.113,722.072a.934.934,0,0,0,0-1.321l-.869-.869a.692.692,0,0,0-.813-.122l.889.889a.588.588,0,0,1,0,.831l-9.685,9.685a.93.93,0,0,1-.394.235l.111.111a.934.934,0,0,0,1.321,0Z",
    transform: "translate(-177.241 -719.68)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002",
    transform: "translate(10.578 0.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M282.569,613.031a2.076,2.076,0,0,0,1.469,3.1,2.077,2.077,0,0,1-.6-2.758.691.691,0,0,0-.106-.841l-.869-.869a.932.932,0,0,0-.784-.265l.788.788A.691.691,0,0,1,282.569,613.031Z",
    transform: "translate(-281.675 -611.394)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003",
    transform: "translate(4.549 12.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M145.078,891.4a2.076,2.076,0,0,0-1.469-3.1,2.078,2.078,0,0,1,.6,2.759.692.692,0,0,0,.106.841l.869.869a.932.932,0,0,0,.784.265l-.788-.789A.692.692,0,0,1,145.078,891.4Z",
    transform: "translate(-143.609 -888.298)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4004",
    "data-name": "Group 4004",
    transform: "translate(0.328 0.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M58.863,612.532l-.869-.869a.934.934,0,0,0-1.321,0l-9.44,9.44a.934.934,0,0,0,0,1.321l.869.869a.691.691,0,0,0,.841.106l.084-.047-.827-.827a.588.588,0,0,1,0-.832l9.238-9.238a.588.588,0,0,1,.832,0l.767.767A.69.69,0,0,0,58.863,612.532Z",
    transform: "translate(-46.959 -611.389)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4009",
    "data-name": "Group 4009",
    transform: "translate(2.303 7.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4005",
    "data-name": "Group 4005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M93.508,781.467a.327.327,0,0,1-.232-.1l-.978-.978a.328.328,0,0,1,.463-.463l.978.978a.327.327,0,0,1-.232.559Z",
    transform: "translate(-92.202 -779.834)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4006",
    "data-name": "Group 4006",
    transform: "translate(1.957 1.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M138.308,826.266a.327.327,0,0,1-.232-.1l-.978-.978a.328.328,0,1,1,.463-.463l.978.978a.327.327,0,0,1-.232.559Z",
    transform: "translate(-137.002 -824.633)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4007",
    "data-name": "Group 4007",
    transform: "translate(3.913 3.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M183.108,871.066a.327.327,0,0,1-.232-.1l-.978-.978a.328.328,0,0,1,.463-.463l.978.979a.328.328,0,0,1-.232.559Z",
    transform: "translate(-181.802 -869.433)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4008",
    "data-name": "Group 4008",
    transform: "translate(5.87 5.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M227.908,915.866a.327.327,0,0,1-.232-.1l-.978-.978a.328.328,0,0,1,.463-.463l.978.979a.328.328,0,0,1-.232.559Z",
    transform: "translate(-226.602 -914.233)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4010",
    "data-name": "Group 4010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M46.248,621.395a1.253,1.253,0,0,1-.892-.369l-.869-.869a1.019,1.019,0,0,1-.157-1.239,1.748,1.748,0,0,0-2.394-2.394,1.019,1.019,0,0,1-1.239-.157l-.869-.869a1.261,1.261,0,0,1,0-1.784l7.728-7.729a.328.328,0,1,1,.463.463l-7.728,7.728a.606.606,0,0,0,0,.857l.869.869a.364.364,0,0,0,.442.055,2.4,2.4,0,0,1,3.291,3.291.364.364,0,0,0,.056.442l.869.869a.607.607,0,0,0,.857,0l9.44-9.44a.607.607,0,0,0,0-.857l-.869-.869a.364.364,0,0,0-.442-.056,2.4,2.4,0,0,1-3.291-3.291.364.364,0,0,0-.056-.442l-.869-.869a.607.607,0,0,0-.857,0,.328.328,0,0,1-.463-.463,1.263,1.263,0,0,1,1.784,0l.869.869a1.019,1.019,0,0,1,.157,1.239,1.748,1.748,0,0,0,2.394,2.394,1.019,1.019,0,0,1,1.239.156l.869.869a1.263,1.263,0,0,1,0,1.784l-9.44,9.44A1.253,1.253,0,0,1,46.248,621.395Z",
    transform: "translate(-39.459 -603.905)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4011",
    "data-name": "Group 4011",
    transform: "translate(8.736 1.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M239.81,627.853a.328.328,0,0,1-.232-.559l.245-.245a.328.328,0,0,1,.463.463l-.245.245A.327.327,0,0,1,239.81,627.853Z",
    transform: "translate(-239.482 -626.953)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4015",
    "data-name": "Group 4015",
    transform: "translate(6.461 4.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4012",
    "data-name": "Group 4012",
    transform: "translate(1.957 1.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M232.53,767.113a.328.328,0,0,1-.232-.559l3.424-3.424a.328.328,0,0,1,.463.463l-3.424,3.424A.327.327,0,0,1,232.53,767.113Z",
    transform: "translate(-232.202 -763.034)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4013",
    "data-name": "Group 4013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M187.729,722.312a.328.328,0,0,1-.232-.559l3.424-3.424a.328.328,0,1,1,.463.463l-3.424,3.424A.327.327,0,0,1,187.729,722.312Z",
    transform: "translate(-187.401 -718.233)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4014",
    "data-name": "Group 4014",
    transform: "translate(0.978 0.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M210.129,744.712a.328.328,0,0,1-.232-.559l3.424-3.424a.328.328,0,0,1,.463.463l-3.424,3.424A.326.326,0,0,1,210.129,744.712Z",
    transform: "translate(-209.801 -740.633)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.d9827cb5345ea76c8589323015c49bb7.svg";
export { ForwardRef as ReactComponent };